import { portalApi } from "api/rtkApi";
import { SERVICES } from "constants/environment";

import type {
  CredentialRequestOptionsJSON,
  PublicKeyCredentialWithAssertionJSON,
} from "@github/webauthn-json";

type InitializeTransactionSigningRequest = {
  transactionIds: string[];
};

type InitializeTransactionSigningResponse = CredentialRequestOptionsJSON;

type FinalizeTransactionSigningRequest = PublicKeyCredentialWithAssertionJSON;

type FinalizeTransactionSigningResponse = {
  token: string;
};

const extendedApi = portalApi.injectEndpoints({
  endpoints: (build) => ({
    initializeTransactionSigning: build.mutation<
      InitializeTransactionSigningResponse,
      InitializeTransactionSigningRequest
    >({
      query: ({ transactionIds }) => ({
        url: "/sca/transactions/signing/initialize",
        body: { transactionIds },
        method: "POST",
      }),
      extraOptions: {
        service: SERVICES.USERS,
      },
    }),

    finalizeTransactionSigning: build.mutation<
      FinalizeTransactionSigningResponse,
      FinalizeTransactionSigningRequest
    >({
      query: (credentials) => ({
        url: "/sca/transactions/signing/finalize",
        body: credentials,
        method: "POST",
      }),
      extraOptions: {
        service: SERVICES.USERS,
      },
    }),
  }),
});

export const {
  useInitializeTransactionSigningMutation,
  useFinalizeTransactionSigningMutation,
} = extendedApi;
